import { useEffect, useState, useMemo, useCallback } from "react"; // <-- useMemo ve useCallback eklendi
import "./App.css";

const apiUrl = "https://api.costaelr.retter.io";
const apiUrlText = "https://api.elrtest.retter.io";

function App() {
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [isValid, setIsValid] = useState(false);
  const [isFormValid, setIsFormValid] = useState(false);

  const [errorText, setErrorText] = useState("");
  const [loading, setLoading] = useState(false);

  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);

  const [passwordSet, setPasswordSet] = useState(false);

  const searchParams = useMemo(() => {
    return new URLSearchParams(document.location.search);
  }, []);

  const email = searchParams.get("email") || '';

  const rules = useMemo(() => ({
    oneUpperCase: {
      validator: () => /[A-Z]/.test(password),
      text: "One uppercase",
    },
    oneLowerCase: {
      validator: () =>
        /[a-z]/.test(password) && password && password.password !== 0,
      text: "One lowercase",
    },
    min8Chars: {
      validator: () => password?.length >= 8,
      text: "Min 8 characters",
    },
    oneSpecialChar: {
      // eslint-disable-next-line no-useless-escape
      validator: () => /[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]/.test(password),
      text: "One special character",
    },
    oneNumber: {
      validator: () => /[0-9]/.test(password),
      text: "One number",
    },
  }), [password]); // Sadece 'password' değiştiğinde yeniden hesaplanacak.

  // 'getVerifyEmail' fonksiyonunu useCallback ile sarmaladık.
  // Bu, 'searchParams' değişmediği sürece fonksiyonun referansının aynı kalmasını sağlar.
  const getVerifyEmail = useCallback(async () => {
    try {
      const token = searchParams.get("token");
      const projectId = searchParams.get("projectId");
      const instanceId = searchParams.get("instanceId");
      const mainUrl = projectId === '4e02k82kb' ? apiUrl : apiUrlText

      if (token && projectId && instanceId) {
        const params = {
          token,
        };
        const response = await fetch(
          `${mainUrl}/${projectId}/CALL/User/verifyEmailForExternalUser/${instanceId}`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify(params),
          }
        );
        const data = await response.json();

        if (!response.ok) {
          throw new Error(data.message);
        }
      }
    } catch (error) {
      setErrorText(error?.message);
    } finally {
      setTimeout(() => {
        setErrorText("");
      }, 4000);
    }
  }, [searchParams]); // 'searchParams' (artık memoized) bağımlılığı eklendi.

  // 'getVerifyEmail' fonksiyonunu kullandığımız useEffect'in ÜSTÜNE taşıdık.
  useEffect(() => {
    const needsEmailVerification = searchParams.get("needsEmailVerification");
    if (needsEmailVerification === "true") {
      getVerifyEmail();
    }
  }, [getVerifyEmail, searchParams]); // Bağımlılıklar artık stabil ve doğru.

  // HATA 3 ve 4 (Satır 40, 47) DÜZELTMESİ:
  // İki ayrı useEffect'i birleştirdik ve tüm bağımlılıkları ekledik.
  useEffect(() => {
    // Password kurallarını doğrula
    const valid = Object.values(rules).every((rule) => rule.validator());
    setIsValid(valid);

    // Formun geçerliliğini (şifre eşleşmesi) kontrol et
    // 'isValid' state'ini de ekleyerek formun hem kurallara hem eşleşmeye uymasını sağladık.
    setIsFormValid(valid && password === confirmPassword);

  }, [password, confirmPassword, rules]); // Artık 3 değere de bağlı.

  // setPasswordRequest'i de useCallback içine almak iyi bir pratiktir,
  // çünkü o da state/proplara (searchParams, password, confirmPassword) bağlıdır.
  const setPasswordRequest = useCallback(async () => {
    try {
      const projectId = searchParams.get("projectId");
      const instanceId = searchParams.get("instanceId");
      const mainUrl = projectId === '4e02k82kb' ? apiUrl : apiUrlText
      setLoading(true);
      const params = {
        token: searchParams.get("token"),
        password,
        passwordAgain: confirmPassword,
      };

      const response = await fetch(
        `${mainUrl}/${projectId}/CALL/User/setPassword/${instanceId}`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(params),
        }
      );
      const data = await response.json();
      setLoading(false);

      if (!response.ok) {
        throw new Error(data.message);
      }

      setPasswordSet(true);
    } catch (error) {
      setPasswordSet(false);
      setErrorText(error?.message);
    } finally {
      setLoading(false);
      setTimeout(() => {
        setErrorText("");
      }, 4000);
    }
  }, [searchParams, password, confirmPassword]); // Bu fonksiyonun bağımlılıkları

  const handlePasswordChange = (e) => {
    setPassword(e.target.value);
  };

  const handleConfirmPasswordChange = (e) => {
    setConfirmPassword(e.target.value);
  };

  const handleSubmit = useCallback((e) => {
    e.preventDefault();
    setPasswordRequest();
  }, [setPasswordRequest]); // setPasswordRequest'e bağlı

  const renderValidationTextProps = (validation) => {
    if (!password) {
      return { backgroundColor: "white", color: "#222322" };
    }
    if (validation()) {
      return {
        backgroundColor: "#4ca239",
        borderColor: "#4ca239",
        color: "white",
      };
    } else {
      return {
        backgroundColor: "#c80000",
        borderColor: "#c80000",
        color: "white",
      };
    }
  };

  const showPasswordHandler = () => {
    setShowPassword(!showPassword);
  };
  const showConfirmPasswordHandler = () => {
    setShowConfirmPassword(!showConfirmPassword);
  };

  return (
    <div className="App">
      <div className="App-inner">
        <div className="App-content">
          <h1 className="title">Create Password</h1>
          <div className="mainDiv">
            <div className="cardStyle">
              {!passwordSet ? (
                <form onSubmit={handleSubmit} name="signupForm" id="signupForm">
                  <div className="inputDiv">
                    <span className="inputLabel" style={{ marginTop: "4px" }}>
                      Enter a new password {email ? `for ${email}` : ''}
                    </span>
                  </div>

                  <div className="inputDiv">
                    <label className="inputLabel" htmlFor="password">
                      New Password
                    </label>
                    <input
                      type={showPassword ? "text" : "password"}
                      id="password"
                      name="password"
                      onChange={handlePasswordChange}
                      value={password}
                      required
                    />
                    <div
                      className="showPasswordContainer"
                      onClick={showPasswordHandler}
                    >
                      {showPassword ? (
                        <img
                          src={"./openEye.svg"}
                          className="App-logo"
                          alt="logo"
                        />
                      ) : (
                        <img
                          src={"./closeEye.svg"}
                          className="App-logo"
                          alt="logo"
                        />
                      )}
                    </div>
                  </div>

                  <div className="inputDiv">
                    <label className="inputLabel" htmlFor="confirmPassword">
                      Confirm Password
                    </label>
                    <input
                      type={showConfirmPassword ? "text" : "password"}
                      id="confirmPassword"
                      name="confirmPassword"
                      onChange={handleConfirmPasswordChange}
                      value={confirmPassword}
                      required
                    />
                    <div
                      className="showPasswordContainer"
                      onClick={showConfirmPasswordHandler}
                    >
                      {showConfirmPassword ? (
                        <img
                          src={"./openEye.svg"}
                          className="App-logo"
                          alt="logo"
                        />
                      ) : (
                        <img
                          src={"./closeEye.svg"}
                          className="App-logo"
                          alt="logo"
                        />
                      )}
                    </div>
                  </div>

                  <div className="badgeContainer">
                    {Object.values(rules).map((rule, index) => {
                      return (
                        <span
                          key={index}
                          className="badge"
                          style={renderValidationTextProps(rule.validator)}
                        >
                          {rule.text}
                        </span>
                      );
                    })}
                  </div>

                  <div className="buttonWrapper">
                    <button
                      type="submit"
                      id="submitButton"
                      disabled={!isValid || !isFormValid || loading}
                      className="submitButton pure-button pure-button-primary"
                    >
                      <span>Change</span>
                      {loading ? <span id="loader"></span> : null}
                    </button>
                  </div>
                  <div>
                    {errorText ? (
                      <span className="errorText">{errorText}</span>
                    ) : null}
                  </div>
                </form>
              ) : (
                <div>
                  <div className="inputDiv">
                    <span className="successTitle">Success.</span>
                    <span
                      className="inputLabel"
                      style={{ fontSize: "16px", marginTop: "8px" }}
                    >
                      Your password has been set. 🔐
                    </span>
                    <span
                      className="inputLabel"
                      style={{ fontSize: "14px", marginTop: "24px" }}
                    >
                      You can download Costa Coffee Club UAE mobile app from
                      here <br />
                      <br /> (link:{" "}
                      <a href="https://onelink.to/3jhb9b">
                        https://onelink.to/3jhb9b
                      </a>
                      ). <br /> <br />
                      Please download it and login with your credentials.
                    </span>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
        <div className="footerContainer">
          {/* HATA 6 (Satır 330) DÜZELTMESİ:
              Güvenlik açığını kapatmak için rel="noopener noreferrer" eklendi. */}
          <a href="https://www.costacoffee.ae/" target="_blank" rel="noopener noreferrer">
            <img src={"./logo.png"} className="App-logo" alt="logo" />
          </a>
          <span className="footerText">
            Having an issue, please contact us form Support Costa Coffee Club
            UAE
          </span>
          <span className="footerText">
            <a href="mailto:support@costacoffeeclubuae.ae">
              support@costacoffeeclubuae.ae
            </a>
          </span>
        </div>
      </div>
    </div>
  );
}

export default App;